


















































import Vue from 'vue';
import { BACKEND_URL } from "../constants";
import OtherContent from '@/components/OtherContent.vue';

const SEARCH_URL = BACKEND_URL + "/search/";

export default Vue.extend({

    components: {
        OtherContent,
    },

    data() {
        return {
            queryInput: '',
            query: '',
            types: null as any,
        };
    },

    mounted() {
        this.query = this.$route.query.query;
        this.queryInput = this.query;
        this.loadData(this.query);
        document.getElementById('searchField')!.focus();
    },

    watch: {
        $route(value: string, oldValue: string) {
            this.query = this.$route.query.query;
            this.queryInput = this.query;
            this.loadData(this.query);
        }
    },

    methods: {
        snippet(item: any) {
            function stripHtml(value: string) {
                const div = document.createElement("div");
                div.innerHTML = value;
                const text = div.textContent || div.innerText || "";
                return text;
            }
            if (item.itemType === 'strip' && 'text' in item && item.text.length > 0) {
                const txt = stripHtml(item.text);
                if (txt.length > 100)
                    return txt.substr(0, txt.lastIndexOf(' ', 100)) + '...';
            }
            if ('name' in item && item.name.length > 0) {
                return stripHtml(item.name);
            }
            if ('question' in item && item.question.length > 0) {
                return stripHtml(item.question);
            }
            return 'untitled';
        },

        updateQuery() {
            this.$router.push({ path: '/search', query: { query: this.queryInput } });
        },

        loadData(query: string) {
            if (query && query.length > 0) {
                const url = SEARCH_URL + "?q=" + encodeURIComponent(query);
                Vue.axios.get(url).then((response: { data: any }) => {
                    this.types = response.data.types;
                });
            } else {
                this.types = null;
            }
        },
    },

});
